import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { isEmbellishmentMethodChangeConformationPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { confirmEmbellishmentMethodChange } from '../../../redux/product/product.actions';
import { setSelectedItemEmbellishmentMethod } from '../../../redux/cart/cart.actions';
import { EmbellishmentMethodChangeConfirmationPopup as EmbellishmentMethodChangeConfirmationPopupComponent } from './embellishment-method-change-confirmation-popup';
const methodIdSelector = createSelector(popupParamsSelector, ({
  methodId
}) => methodId);
const isItemEditSelector = createSelector(popupParamsSelector, ({
  isItemEdit
}) => isItemEdit);
const itemIdSelector = createSelector(popupParamsSelector, ({
  itemId
}) => itemId);
const productionTimeIdSelector = createSelector(popupParamsSelector, ({
  productionTimeId
}) => productionTimeId);
const storageTypeSelector = createSelector(popupParamsSelector, ({
  storageType
}) => storageType);
const mapStateToProps = createStructuredSelector({
  open: isEmbellishmentMethodChangeConformationPopupShownSelector,
  methodId: methodIdSelector,
  isItemEdit: isItemEditSelector,
  itemId: itemIdSelector,
  productionTimeId: productionTimeIdSelector,
  storageType: storageTypeSelector
});
const mapDispatchToProps = dispatch => ({
  onConfirm: methodId => {
    dispatch(confirmEmbellishmentMethodChange(methodId));
    dispatch(hidePopup());
  },
  onCancel: () => {
    dispatch(hidePopup());
  },
  onItemConfirm: params => {
    dispatch(setSelectedItemEmbellishmentMethod(params));
  }
});
export const EmbellishmentMethodChangeConfirmationPopup = connect(mapStateToProps, mapDispatchToProps)(EmbellishmentMethodChangeConfirmationPopupComponent);